<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
      <b-form-select class="w-25 float-left location-filter-select" v-model="locationFilter" :options="locationFilterOptions"></b-form-select>
      <b-button-toolbar class="mr-3 float-right">
        <b-form-radio-group id="radiosBtn" buttons button-variant="outline-secondary" v-model="statisticsTimeInterval" name="radiosBtn">
          <b-form-radio class="mx-0" value="Day" >Last 30 Days</b-form-radio>
          <b-form-radio class="mx-0" value="Month" >Month</b-form-radio>
          <b-form-radio class="mx-0" value="Quarter">Quarter</b-form-radio>
          <b-form-radio class="mx-0" value="Year" >Year</b-form-radio>
        </b-form-radio-group>
        <date-range-picker
          ref="picker"
          opens="left"
          :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
          :maxDate="new Date()"
          singleDatePicker="range"
          :timePicker="false"
          :timePicker24Hour="false"
          :showWeekNumbers="false"
          :showDropdowns="true"
          :autoApply="false"
          v-model="customDateRange"
          :ranges="false"
          @select="handleSelect"
        >
          <template #header>
            <div class="date-range-picker__header">
              <b-form-group
                label="Start Date:"
                label-for="startDate"
                label-size="sm"
                class="mb-0"
              >
                <b-form-input
                  class="mb-0"
                  data-vv-name="startDate"
                  data-vv-as="startDate"
                  id="startDate"
                  size="sm"
                  type='text'
                  name="startDate"
                  v-model="customDateRange.startDate"
                />
              </b-form-group>
              <b-form-group
                label="End Date:"
                label-for="endDate"
                label-size="sm"
                class="mb-0"
              >
                <b-form-input
                  class="mb-0"
                  data-vv-name="endDate"
                  data-vv-as="endDate"
                  id="endDate"
                  size="sm"
                  type='text'
                  name="endDate"
                  v-model="customDateRange.endDate"
                />
              </b-form-group>
            </div>
          </template>
          <template v-slot:input style="min-width: 350px;">
            <b-button :class="['mx-0', { 'active': statisticsTimeInterval === 'Custom' }]" variant="outline-secondary">
              Custom
            </b-button>
          </template>
          <template v-slot:footer="picker">
            <div class="date-range-picker__footer">
              <b-button type="button" @click="saveCustomDateRange(picker.clickApply)" variant="outline-primary">
                Save
              </b-button>
            </div>
          </template>
        </date-range-picker>
        <b-form-radio button class="mx-0" v-model="statisticsTimeInterval" button-variant="outline-secondary" value="All">All</b-form-radio>
      </b-button-toolbar>
      <b-button-toolbar style="clear:both; margin-right: 1rem !important; margin-top: 10px; float:right;">
        <download-csv
          style="display:inline"
          :data=allUsers
          name="users.csv">
          <b-btn class="float-right" variant="primary" style="margin-right: 5px">Download Users</b-btn>
        </download-csv>
        <download-csv
            :data=allOrgs
            name="organizations.csv">
            <b-btn class="float-right" variant="primary" style="margin-right: 5px">Download Orgs</b-btn>
          </download-csv>
        <download-csv
            style="display:inline"
            :data=allGroups
            name="groups.csv">
            <b-btn class="float-right" variant="primary" style="margin-right: 5px">Download Groups</b-btn>
          </download-csv>
        <download-csv
          style="display:inline"
          :data=allLogs
          name="logs.csv">
          <b-btn class="float-right" variant="primary">Download Logs</b-btn>
        </download-csv>
      </b-button-toolbar>
      </b-col>
    </b-row>
    <b-tabs v-model="tabIndex" id="global-statistics-tabs">
      <b-tab title="Overall Demographics">
        <b-row>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-info">
              <b-row>
                <b-col>
                  <div class="h1 mb-0"> {{ rptgeneralCounts.personCount === null ? 0 : rptgeneralCounts.personCount }} </div>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-note"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">All People</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-danger clickable-card" @click="goToConfirmed">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ rptgeneralCounts.confirmedPersonCount === null ? 0 : rptgeneralCounts.confirmedPersonCount }} </span>
                  <span class="text-muted">({{ percentConfirmedPersons }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Confirmed Victims</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="clickable-card" @click="goToBlankConfirmed">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ rptgeneralCounts.possiblePersonCount === null ? 0 : rptgeneralCounts.possiblePersonCount }} </span>
                  <span class="text-muted">({{ percentUnconfirmedPersons }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>

              <small class="text-muted text-uppercase font-weight-bold">Others</small>
            </b-card>
          </b-col>
        </b-row>
        <!-- Persons By Time -->
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">People over Time</h4>
              <hr>
              <!--
              <b-button-toolbar class="float-left">
                <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="personsTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
              -->
            </b-col>
          </b-row>
          <main-chart
            class="chart-wrapper"
            style="height:200px;margin-top:40px;"
            height="200"
            chartName="People"
            :apiData="rptpersonCountsByTime"
            v-if="!rptpersonCountsByTimeError"
          >
          </main-chart>
          <p v-if="rptpersonCountsByTimeError">There is no data for this chart.</p>
        </b-card>
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
              <b-col>
                <h4 class="card-title mb-0">Demographics by Status</h4>
                <hr/>
              </b-col>
            </b-row>
            <b-form-group
              label-size='lg'
              label-text-align="left"
              label-class='addpersonlabel'
              label='Group By'
              label-for='demographic'
              horizontal
              style="width:400px"
            >
              <b-form-select
                size="lg"
                :options="biographicOptions"
                id='demographic'
                v-model='demographicField'
              >
              </b-form-select>
            </b-form-group>
            <p v-if="rptPersonCountsByDemographicError">There is no data for this chart.</p>
            <b-row v-if="!rptPersonCountsByDemographicError">
              <b-col sm="4">
                <h4 class="text-center">All People</h4>
                <pie-chart
                  class="chart-wrapper"
                  chartName="Total People"
                  :apiData="rptPersonCountsByDemographic"
                  valueField="personCount"
                  :groupedBy="demographicField"
                ></pie-chart>
              </b-col>
              <b-col sm="4">
                <h4 class="text-center">Confirmed Victims</h4>
                <pie-chart
                  class="chart-wrapper"
                  chartName="Confirmed Victims"
                  :apiData="rptPersonCountsByDemographic"
                  valueField="confirmedVictimCount"
                  :groupedBy="demographicField"
                ></pie-chart>
              </b-col>
              <b-col sm="4">
                <h4 class="text-center">Others</h4>
                <pie-chart
                  class="chart-wrapper"
                  chartName="Possible Victims"
                  :apiData="rptPersonCountsByDemographic"
                  valueField="possibleVictimCount"
                  :groupedBy="demographicField"
                ></pie-chart>
              </b-col>
            </b-row>
         </b-card>
        </b-card-group>
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
                <b-col>
                  <h4 class="card-title mb-0">Demographics over Time</h4>
                  <hr/>
                </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label-size='lg'
                  label-text-align="left"
                  label-class='addpersonlabel'
                  label='Group By'
                  label-for='demographic'
                  horizontal
                  style="width:400px"
                >
                  <b-form-select
                    size="lg"
                    :options="biographicOptions"
                    id='demographic'
                    v-model='demographicByTimeField'
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <!--
                <b-button-toolbar class="float-right">
                  <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="demographicByTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                  </b-form-radio-group>
                </b-button-toolbar>
                -->
              </b-col>
            </b-row>
            <!-- STACKED LINE CHARTS -->
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">All People</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptpersonDemographicsOverTime"
                  valueField="timeInterval"
                  :demographicName="demographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!rptpersonDemographicsOverTimeError"
                ></stacked-line-chart>
                <p v-if="rptpersonDemographicsOverTimeError">There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Confirmed Victims</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptpersonDemographicsOverTimeConfirmed"
                  valueField="timeInterval"
                  :demographicName="demographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!rptpersonDemographicsOverTimeConfirmedError"
                ></stacked-line-chart>
                <p v-if="rptpersonDemographicsOverTimeConfirmedError">There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Others</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptpersonDemographicsOverTimeUnconfirmed"
                  valueField="timeInterval"
                  :demographicName="demographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!rptpersonDemographicsOverTimeUnconfirmedError"
                ></stacked-line-chart>
                <p v-if="rptpersonDemographicsOverTimeUnconfirmedError">There is no data for this chart.</p>
              </b-col>
            </b-row>
         </b-card>
        </b-card-group>
      </b-tab>
      <b-tab title="CSE-IT">
        <b-row>
          <b-col sm="12" md="12">
            <download-csv
              :data="screeningsByOrg"
              name="screenings.csv"
            >
              <b-btn class="float-right" variant="primary" style="margin-right: 5px; margin-bottom: 10px;">Download Screenings by Concern Level</b-btn>
            </download-csv>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-info">
              <b-row>
                <b-col>
                  <div class="h1 mb-0"> {{ rptgeneralCounts.cseitCount === null ? 0 : rptgeneralCounts.cseitCount }} </div>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-note"></i> </div>
                </b-col>
              </b-row>
              <!--
              <div class="h1 text-muted text-right mb-4">
                <i class="icon-note"></i>
              </div>
              <div class="h1 mb-0"> {{ generalCounts.cseitCount === null ? 0 : generalCounts.cseitCount }} </div>
              -->
              <small class="text-muted text-uppercase font-weight-bold">CSE-IT Screenings</small>
              <br><small class="text-muted text-uppercase"> {{ rptgeneralCounts.cseitCountAllPerson === null ? 0 : rptgeneralCounts.cseitCountAllPerson }} unique person(s)</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="clickable-card" @click="goToNoConcern">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ rptgeneralCounts.cseitCountNoConcern === null ? 0 : rptgeneralCounts.cseitCountNoConcern }} </span>
                  <span class="text-muted">({{ percentCseitNoconcern }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <!--
              <div class="h1 text-muted text-right mb-4">
                <i class="icon-pie-chart"></i>
              </div>
              <div><span class="h1 mb-0"> {{ generalCounts.cseitCountNoConcern === null ? 0 : generalCounts.cseitCountNoConcern }} </span><span class="text-muted">({{ percentCseitNoconcern }}%)</span></div>
              -->
              <small class="text-muted text-uppercase font-weight-bold">No Concern</small>
              <br><small class="text-muted text-uppercase"> {{ rptgeneralCounts.cseitCountNoConcernPerson === null ? 0 : rptgeneralCounts.cseitCountNoConcernPerson }} unique person(s)</small>
              <br>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-warning clickable-card" @click="goToPossibleConcern">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ rptgeneralCounts.cseitCountPossibleConcern === null ? 0 : rptgeneralCounts.cseitCountPossibleConcern }} </span>
                  <span class="text-muted">({{ percentCseitPossibleConcern }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <!--
              <div class="h1 text-muted text-right mb-4">
                <i class="icon-pie-chart"></i>
              </div>
              <div><span class="h1 mb-0"> {{ generalCounts.cseitCountPossibleConcern === null ? 0 : generalCounts.cseitCountPossibleConcern }} </span><span class="text-muted">({{ percentCseitPossibleConcern }}%)</span></div>
              -->
              <small class="text-muted text-uppercase font-weight-bold">Possible Concern</small>
              <br><small class="text-muted text-uppercase"> {{ rptgeneralCounts.cseitCountPossibleConcernPerson === null ? 0 : rptgeneralCounts.cseitCountPossibleConcernPerson }} unique person(s)</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-danger clickable-card" @click="goToClearConcern">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ rptgeneralCounts.cseitCountClearConcern === null ? 0 : rptgeneralCounts.cseitCountClearConcern }} </span>
                  <span class="text-muted">({{ percentCseitClearConcern }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <!--
              <div class="h1 text-muted text-right mb-4">
                <i class="icon-pie-chart"></i>
              </div>
              <div><span class="h1 mb-0"> {{ generalCounts.cseitCountClearConcern === null ? 0 : generalCounts.cseitCountClearConcern }} </span><span class="text-muted">({{ percentCseitClearConcern }}%)</span></div>
              -->
              <small class="text-muted text-uppercase font-weight-bold">Clear Concern</small>
              <br><small class="text-muted text-uppercase"> {{ rptgeneralCounts.cseitCountClearConcernPerson === null ? 0 : rptgeneralCounts.cseitCountClearConcernPerson }} unique person(s)</small>
            </b-card>
          </b-col>
        </b-row>
        <!-- CSE-IT By Time -->
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">Screenings over Time</h4>
              <hr>
              <!--
              <b-button-toolbar class="float-left">
                <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="cseitTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
              -->
            </b-col>
          </b-row>
          <main-chart
            class="chart-wrapper"
            style="height:200px;margin-top:40px;"
            height=200
            chartName="Screenings"
            :apiData="rptcseitCountsByTime"
            v-if="!rptcseitCountsByTimeError"
          >
          </main-chart>
          <p v-if="rptcseitCountsByTimeError">There is no data for this chart.</p>
        </b-card>
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
              <b-col>
                <h4 class="card-title mb-0">Demographics by Status</h4>
                <hr/>
              </b-col>
            </b-row>
            <b-form-group
              label-size='lg'
              label-text-align="left"
              label-class='addpersonlabel'
              label='Group By'
              label-for='cseitDemographic'
              horizontal
              style="width:400px"
            >
              <b-form-select
                size="lg"
                :options="biographicOptions"
                id='cseitDemographic'
                v-model='cseitDemographicField'
              >
              </b-form-select>
            </b-form-group>
            <p v-if="rptcseitCountsByDemographicError || (
              rptcseitCountsByDemographic &&
              rptcseitCountsByDemographic.length <= 0
            )">There is no data for this chart.</p>
            <div v-else>
              <b-row>
                <b-col sm="6" class="column-wrapper">
                  <h4 class="text-center">All Screenings</h4>
                  <pie-chart
                    chartName="Screenings"
                    :apiData="rptcseitCountsByDemographic"
                    valueField="cseitCount"
                    :groupedBy="cseitDemographicField"
                  ></pie-chart>
                </b-col>
                <b-col sm="6" class="column-wrapper">
                  <h4 class="text-center">No Concern</h4>
                  <pie-chart
                    chartName="No Concern"
                    :apiData="rptcseitCountsByDemographic"
                    valueField="cseitCountNoConcern"
                    :groupedBy="cseitDemographicField"
                  ></pie-chart>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6" class="column-wrapper">
                  <h4 class="text-center">Possible Concern</h4>
                  <pie-chart
                    chartName="Possible Concern"
                    :apiData="rptcseitCountsByDemographic"
                    valueField="cseitCountPossibleConcern"
                    :groupedBy="cseitDemographicField"
                  ></pie-chart>
                </b-col>
                <b-col sm="6" class="column-wrapper">
                  <h4 class="text-center">Clear Concern</h4>
                  <pie-chart
                    chartName="Clear Concern"
                    :apiData="rptcseitCountsByDemographic"
                    valueField="cseitCountClearConcern"
                    :groupedBy="cseitDemographicField"
                  ></pie-chart>
                </b-col>
              </b-row>
            </div>
         </b-card>
        </b-card-group>
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
                <b-col>
                  <h4 class="card-title mb-0">Demographics over Time</h4>
                  <hr/>
                </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label-size='lg'
                  label-text-align="left"
                  label-class='addpersonlabel'
                  label='Group By'
                  label-for='demographic'
                  horizontal
                  style="width:400px"
                >
                  <b-form-select
                    size="lg"
                    :options="biographicOptions"
                    id='demographic'
                    v-model='cseitDemographicByTimeField'
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <!--
                <b-button-toolbar class="float-right">
                  <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="cseitDemographicByTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                  </b-form-radio-group>
                </b-button-toolbar>
                -->
              </b-col>
            </b-row>
            <!-- Stacked Line Charts -->
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">All Screenings</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptcseitDemographicsByTime"
                  valueField="timeInterval"
                  :demographicName="cseitDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!rptcseitDemographicsByTimeError"
                ></stacked-line-chart>
                <p v-if="rptcseitDemographicsByTimeError">There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">No Concern</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptcseitDemographicsByTimeNoConcern"
                  valueField="timeInterval"
                  :demographicName="cseitDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!rptcseitDemographicsOverTimeNoConcernError"
                ></stacked-line-chart>
                <p v-if="rptcseitDemographicsOverTimeNoConcernError">There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Possible Concern</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptcseitDemographicsByTimePossibleConcern"
                  valueField="timeInterval"
                  :demographicName="cseitDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!rptcseitDemographicsOverTimePossibleConcernError"
                ></stacked-line-chart>
                <p v-if="rptcseitDemographicsOverTimePossibleConcernError">There is no data for this chart.</p>
              </b-col>
            </b-row>
              <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Clear Concern</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptcseitDemographicsByTimeClearConcern"
                  valueField="timeInterval"
                  :demographicName="cseitDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!rptcseitDemographicsOverTimeClearConcernError"
                ></stacked-line-chart>
                <p v-if="rptcseitDemographicsOverTimeClearConcernError">There is no data for this chart.</p>
              </b-col>
            </b-row>
         </b-card>
        </b-card-group>
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">Indicators</h4>
              <hr>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
              <b-form-group
                label-for='demographic'
                horizontal
                style="width:400px"
              >
                <b-form-select
                  size="lg"
                  :options="cseitIndicatorOptions"
                  id='demographic'
                  v-model='cseitIndicatorOption'
                >
                </b-form-select>
              </b-form-group>
          </b-row>
          <b-row>
            <b-col sm="12">
              <horizontal-bar-chart
                :apiData="rptCseitIndicators"
                v-if="!rptCseitIndicatorsError"
              >
              </horizontal-bar-chart>
              <p v-if="rptCseitIndicatorsError">There is no data for this chart.</p>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab title="Lighthouse Indicators">
        <b-row>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-info">
              <b-row>
                <b-col>
                  <div class="h1 mb-0"> {{ rptgeneralCounts.assessmentCount === null ? 0 : rptgeneralCounts.assessmentCount }} </div>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-note"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">All Lighthouse Screenings</small>
              <br><small class="text-muted text-uppercase"> {{ rptgeneralCounts.assessmentCountAllPerson === null ? 0 : rptgeneralCounts.assessmentCountAllPerson }} unique person(s)</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card>
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ rptgeneralCounts.assessmentCountNotEnoughInfo  === null ? 0 : rptgeneralCounts.assessmentCountNotEnoughInfo }} </span>
                  <span class="text-muted">({{ percentAssessmentNotenoughinfo }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"><i class="icon-pie-chart"></i></div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Not Enough Info</small>
              <br><small class="text-muted text-uppercase"> {{ rptgeneralCounts.assessmentCountNotEnoughInfoPerson === null ? 0 : rptgeneralCounts.assessmentCountNotEnoughInfoPerson }} unique person(s)</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-warning">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ rptgeneralCounts.assessmentCountPossible === null ? 0 : rptgeneralCounts.assessmentCountPossible }} </span>
                  <span class="text-muted">({{ percentAssessmentPossible }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"><i class="icon-pie-chart"></i></div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Possible Victim</small>
              <br><small class="text-muted text-uppercase"> {{ rptgeneralCounts.assessmentCountPossiblePerson === null ? 0 : rptgeneralCounts.assessmentCountPossiblePerson }} unique person(s)</small>
            </b-card>
          </b-col>
        </b-row>
        <!-- Assessments By Time -->
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">Lighthouse Screenings over Time</h4>
              <hr>
              <!--
              <b-button-toolbar class="float-left">
                <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="assessmentsTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
              -->
            </b-col>
          </b-row>
          <main-chart
            class="chart-wrapper"
            style="height:200px;margin-top:40px;"
            height="200"
            chartName="Assessments"
            :apiData="rptassessmentCountsByTime"
            v-if="!rptassessmentCountsByTimeError"
          >
          </main-chart>
          <p v-if="rptassessmentCountsByTimeError">There is no data for this chart.</p>
        </b-card>
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
              <b-col>
                <h4 class="card-title mb-0">Demographics by Status</h4>
                <hr/>
              </b-col>
            </b-row>
            <b-form-group
              label-size='lg'
              label-text-align="left"
              label-class='addpersonlabel'
              label='Group By'
              label-for='demographic'
              horizontal
              style="width:400px"
            >
              <b-form-select
                size="lg"
                :options="biographicOptions"
                id='demographic'
                v-model='assessmentDemographicField'
              >
              </b-form-select>
            </b-form-group>
            <p v-if="rptassessmentByDemographicError">There is no data for this chart.</p>
            <b-row v-if="!rptassessmentByDemographicError">
              <b-col sm="4">
                <h4 class="text-center">All Lighthouse Screenings</h4>
                <pie-chart
                  class="chart-wrapper"
                  chartName="Total People"
                  :apiData="rptassessmentCountsByDemographic"
                  valueField="assessmentCount"
                  :groupedBy="assessmentDemographicField"
                ></pie-chart>
              </b-col>
              <b-col sm="4">
                <h4 class="text-center">Not Enough Information</h4>
                <pie-chart
                  class="chart-wrapper"
                  chartName="Possible Victims"
                  :apiData="rptassessmentCountsByDemographic"
                  valueField="assessmentCountNotEnoughInfo"
                  :groupedBy="assessmentDemographicField"
                ></pie-chart>
              </b-col>
              <b-col sm="4">
                <h4 class="text-center">Possible Victim</h4>
                <pie-chart
                  class="chart-wrapper"
                  chartName="Confirmed Victims"
                  :apiData="rptassessmentCountsByDemographic"
                  valueField="assessmentCountPossible"
                  :groupedBy="assessmentDemographicField"
                ></pie-chart>
              </b-col>
            </b-row>
         </b-card>
        </b-card-group>
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
                <b-col>
                  <h4 class="card-title mb-0">Demographics over Time</h4>
                  <hr/>
                </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label-size='lg'
                  label-text-align="left"
                  label-class='addpersonlabel'
                  label='Group By'
                  label-for='demographic'
                  horizontal
                  style="width:400px"
                >
                  <b-form-select
                    size="lg"
                    :options="biographicOptions"
                    id='demographic'
                    v-model='assessmentDemographicByTimeField'
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <!--
                <b-button-toolbar class="float-right">
                  <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="assessmentDemographicByTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                  </b-form-radio-group>
                </b-button-toolbar>
                -->
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">All Lighthouse Screenings</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptassessmentDemographicsByTime"
                  valueField="timeInterval"
                  :demographicName="assessmentDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!rptassessmentDemographicsByTimeError"
                ></stacked-line-chart>
                <p v-if="rptassessmentDemographicsByTimeError">There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Not Enough Information</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptassessmentDemographicsByTimeNoInfoVictims"
                  valueField="timeInterval"
                  :demographicName="assessmentDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!rptassessmentDemographicsOverTimeNoInfoError"
                ></stacked-line-chart>
                <p v-if="rptassessmentDemographicsOverTimeNoInfoError">There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Possible Victim</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptassessmentDemographicsByTimePossibleVictims"
                  valueField="timeInterval"
                  :demographicName="assessmentDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!rptassessmentDemographicsOverTimePossibleError"
                ></stacked-line-chart>
                <p v-if="rptassessmentDemographicsOverTimePossibleError">There is no data for this chart.</p>
              </b-col>
            </b-row>
         </b-card>
        </b-card-group>
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">Indicators</h4>
              <hr>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
              <b-form-group
                label-for='demographic'
                horizontal
                style="width:400px"
              >
                <b-form-select
                  size="lg"
                  :options="assessmentIndicatorOptions"
                  id='demographic'
                  v-model='assessmentIndicatorOption'
                >
                </b-form-select>
              </b-form-group>
          </b-row>
          <b-row>
            <b-col sm="12">
              <horizontal-bar-chart
                :apiData="rptassessmentIndicators"
                v-if="!rptassessmentIndicatorsError"
              >
              </horizontal-bar-chart>
              <p v-if="rptassessmentIndicatorsError">There is no data for this chart.</p>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab title="Labor Screening">
        <!-- Labor Screening Count Cards -->
        <b-row>
          <b-col sm="12" md="12">
            <download-csv
              :data="laborScreeningsByOrg"
              name="screenings.csv"
            >
              <b-btn class="float-right" variant="primary" style="margin-right: 5px; margin-bottom: 10px;">Download Screenings by Conclusion</b-btn>
            </download-csv>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-info">
              <b-row>
                <b-col>
                  <div class="h1 mb-0">
                    {{ rptgeneralCounts.lsCount }}
                  </div>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-note"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Labor Screenings</small>
              <br><small class="text-muted text-uppercase"> {{ rptgeneralCounts.lsCountAllPerson }} unique person(s)</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="clickable-card" @click="goToLSNotEnoughInfo">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ rptgeneralCounts.lsCountNotEnoughInfo }} </span>
                  <span class="text-muted">({{ percentLsNotEnoughInfo }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Not Enough Info</small>
              <br><small class="text-muted text-uppercase"> {{ rptgeneralCounts.lsCountNotEnoughInfoPerson }} unique person(s)</small>
              <br>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-warning clickable-card" @click="goToLSVulnerable">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ rptgeneralCounts.lsCountVulnerable }} </span>
                  <span class="text-muted">({{ percentLsVulnerable }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Level 1: Concern</small>
              <br><small class="text-muted text-uppercase"> {{ rptgeneralCounts.lsCountVulnerablePerson }} unique person(s)</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-danger clickable-card" @click="goToLSHighlyVulnerable">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ rptgeneralCounts.lsCountHighlyVulnerable }} </span>
                  <span class="text-muted">({{ percentLsHighlyVulnerable }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Level 2: Indicated</small>
              <br><small class="text-muted text-uppercase"> {{ rptgeneralCounts.lsCountHighlyVulnerablePerson }} unique person(s)</small>
            </b-card>
          </b-col>
        </b-row>
        <!-- Labor Screening By Time -->
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">Screenings over Time</h4>
              <hr>
            </b-col>
          </b-row>
          <main-chart
            v-if="!rptLaborScreeningCountsByTimeError"
            class="chart-wrapper"
            style="height:200px;margin-top:40px;"
            height=200
            chartName="Screenings"
            :apiData="rptLaborScreeningCountsByTime"
          />
          <p v-else>There is no data for this chart.</p>
        </b-card>
        <!-- Labor Screenings By Demographic -->
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
              <b-col>
                <h4 class="card-title mb-0">Demographics by Status</h4>
                <hr/>
              </b-col>
            </b-row>
            <b-form-group
              label-size='lg'
              label-text-align="left"
              label-class='addpersonlabel'
              label='Group By'
              label-for='laborScreeningDemographic'
              horizontal
              style="width:400px"
            >
              <b-form-select
                size="lg"
                :options="biographicOptions"
                id='laborScreeningDemographic'
                v-model='laborScreeningDemographicField'
              >
              </b-form-select>
            </b-form-group>
            <p
              v-if="rptLaborScreeningCountsByDemographicError || (
                rptLaborScreeningCountsByDemographic &&
                rptLaborScreeningCountsByDemographic.length <= 0
              )"
            >
              There is no data for this chart.
            </p>
            <div v-else>
              <b-row>
                <b-col sm="6" class="column-wrapper">
                  <h4 class="text-center">All Screenings</h4>
                  <pie-chart
                    chartName="Screenings"
                    :apiData="rptLaborScreeningCountsByDemographic"
                    valueField="lsCount"
                    :groupedBy="laborScreeningDemographicField"
                  ></pie-chart>
                </b-col>
                <b-col sm="6" class="column-wrapper">
                  <h4 class="text-center">Not Enough Info</h4>
                  <pie-chart
                    chartName="Not Enough Info"
                    :apiData="rptLaborScreeningCountsByDemographic"
                    valueField="lsCountNotEnoughInfo"
                    :groupedBy="laborScreeningDemographicField"
                  ></pie-chart>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6" class="column-wrapper">
                  <h4 class="text-center">Level 1: Concern</h4>
                  <pie-chart
                    chartName="Level 1: Concern"
                    :apiData="rptLaborScreeningCountsByDemographic"
                    valueField="lsCountVulnerable"
                    :groupedBy="laborScreeningDemographicField"
                  ></pie-chart>
                </b-col>
                <b-col sm="6" class="column-wrapper">
                  <h4 class="text-center">Level 2: Indicated</h4>
                  <pie-chart
                    chartName="Level 2: Indicated"
                    :apiData="rptLaborScreeningCountsByDemographic"
                    valueField="lsCountHighlyVulnerable"
                    :groupedBy="laborScreeningDemographicField"
                  ></pie-chart>
                </b-col>
              </b-row>
            </div>
         </b-card>
        </b-card-group>
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
                <b-col>
                  <h4 class="card-title mb-0">Demographics over Time</h4>
                  <hr/>
                </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label-size='lg'
                  label-text-align="left"
                  label-class='addpersonlabel'
                  label='Group By'
                  label-for='demographic'
                  horizontal
                  style="width:400px"
                >
                  <b-form-select
                    size="lg"
                    :options="biographicOptions"
                    id='demographic'
                    v-model='laborScreeningDemographicByTimeField'
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
              </b-col>
            </b-row>
            <!-- Stacked Line Charts -->
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">All Screenings</h4>
                <stacked-line-chart
                  v-if="!rptLaborScreeningDemographicsByTimeError"
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptLaborScreeningDemographicsByTime"
                  valueField="timeInterval"
                  :demographicName="laborScreeningDemographicByTimeField"
                  :colorValues="colorValues"
                ></stacked-line-chart>
                <p v-else>There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Not Enough Info</h4>
                <stacked-line-chart
                  v-if="!rptLaborScreeningDemographicsByTimeError"
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptLaborScreeningDemographicsByTime"
                  valueField="timeInterval"
                  :demographicName="laborScreeningDemographicByTimeField"
                  demographicTotalKey="demographicNotEnoughInfo"
                  :colorValues="colorValues"
                ></stacked-line-chart>
                <p v-else>There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Level 1: Concern</h4>
                <stacked-line-chart
                  v-if="!rptLaborScreeningDemographicsByTimeError"
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptLaborScreeningDemographicsByTime"
                  valueField="timeInterval"
                  :demographicName="laborScreeningDemographicByTimeField"
                  demographicTotalKey="demographicVulnerable"
                  :colorValues="colorValues"
                ></stacked-line-chart>
                <p v-else>There is no data for this chart.</p>
              </b-col>
            </b-row>
              <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Level 2: Indicated</h4>
                <stacked-line-chart
                  v-if="!rptLaborScreeningDemographicsByTimeError"
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptLaborScreeningDemographicsByTime"
                  valueField="timeInterval"
                  :demographicName="laborScreeningDemographicByTimeField"
                  demographicTotalKey="demographicHighlyVulnerable"
                  :colorValues="colorValues"
                ></stacked-line-chart>
                <p v-else>There is no data for this chart.</p>
              </b-col>
            </b-row>
         </b-card>
        </b-card-group>
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">Indicators</h4>
              <hr>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
              <b-form-group
                label-for='demographic'
                horizontal
                style="width:400px"
              >
                <b-form-select
                  size="lg"
                  :options="laborScreeningIndicatorOptions"
                  id='demographic'
                  v-model='laborScreeningIndicatorOption'
                >
                </b-form-select>
              </b-form-group>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-tabs>
                <b-tab title="Ends">
                  <horizontal-bar-chart
                    v-if="(
                      !rptLaborScreeningIndicatorsError &&
                      rptLaborScreeningIndicatorsEnds &&
                      rptLaborScreeningIndicatorsEnds.length
                    )"
                    :transformKeyFunction="transformLaborScreeningIndicatorKey"
                    :apiData="rptLaborScreeningIndicatorsEnds"
                  />
                  <p v-else>There is no data for this chart.</p>
                </b-tab>
                <b-tab title="Means">
                  <horizontal-bar-chart
                    v-if="(
                      !rptLaborScreeningIndicatorsError &&
                      rptLaborScreeningIndicatorsMeans &&
                      rptLaborScreeningIndicatorsMeans.length
                    )"
                    :transformKeyFunction="transformLaborScreeningIndicatorKey"
                    :apiData="rptLaborScreeningIndicatorsMeans"
                  />
                  <p v-else>There is no data for this chart.</p>
                </b-tab>
                <b-tab title="Process">
                  <horizontal-bar-chart
                    v-if="(
                      !rptLaborScreeningIndicatorsError &&
                      rptLaborScreeningIndicatorsProcess &&
                      rptLaborScreeningIndicatorsProcess.length
                    )"
                    :transformKeyFunction="transformLaborScreeningIndicatorKey"
                    :apiData="rptLaborScreeningIndicatorsProcess"
                  />
                  <p v-else>There is no data for this chart.</p>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import HorizontalBarChart from '../charts/HorizontalBarChart'
import MainChart from '../charts/MainChart'
import PieChart from '../charts/PieChart'
// import StackedBarChart from '../charts/StackedBarChart'
import StackedLineChart from '../charts/StackedLineChart'
import JsonCSV from 'vue-json-csv'
import AssessmentIndicatorsTile from '../charts/AssessmentIndicators'
import AssessmentIndicatorsComparison from '../charts/AssessmentIndicatorsComparison'

import { mapGetters } from 'vuex'
import { LABOR_SCREENING_CONCLUSION, GLOBAL_REPORTS_TAB_INDEX } from '../../helpers/enums'

export default {
  name: 'reports',
  components: {
    HorizontalBarChart,
    MainChart,
    PieChart,
    AssessmentIndicatorsTile,
    AssessmentIndicatorsComparison,
    // StackedBarChart,
    StackedLineChart,
    'download-csv': JsonCSV
  },
  computed: {
    ...mapGetters({
      biographicOptions: 'getPersonBiographicOptions',
      rptassessmentIndicators: 'getReportAssessmentIndicators',
      rptassessmentIndicatorsByPerson: 'getReportAssessmentIndicatorsByPerson',
      rptgeneralCounts: 'getReportGeneralCounts',
      rptassessmentCountsByTime: 'getReportAssessmentCountsByTime',
      rptpersonCountsByTime: 'getReportPersonCountsByTime',
      rptpersonCountsByDemographic: 'getPersonCountsByDemographic',
      rptPersonCountsByDemographic: 'getReportPersonCountsByDemographic',
      rptcseitCountsByIndicators: 'getReportCseitCountsByIndicators',
      assessmentFields: 'getAssessmentFields',
      assessmentIndicatorOptions: 'getAssessmentIndicatorOptions',
      rptcseitCountsByTime: 'getReportCseitCountsByTime',
      rptLaborScreeningCountsByTime: 'getRptLaborScreeningCountsByTime',
      rptLaborScreeningCountsByTimeError: 'getRptLaborScreeningCountsByTimeError',
      rptLaborScreeningCountsByDemographic: 'getRptLaborScreeningCountsByDemographic',
      rptLaborScreeningCountsByDemographicError: 'getRptLaborScreeningCountsByDemographicError',
      rptLaborScreeningDemographicsByTime: 'getRptLaborScreeningDemographicsByTime',
      rptLaborScreeningDemographicsByTimeError: 'getRptLaborScreeningDemographicsByTimeError',
      rptLaborScreeningIndicators: 'getRptLaborScreeningIndicators',
      rptLaborScreeningIndicatorsError: 'getRptLaborScreeningIndicatorsError',
      rptpersonDemographicsOverTime: 'getReportPersonDemographicsOverTime',
      rptpersonDemographicsOverTimeUnconfirmed: 'getReportPersonDemographicsOverTimeUnconfirmed',
      rptpersonDemographicsOverTimeConfirmed: 'getReportPersonDemographicsOverTimeConfirmed',
      rptcseitCountsByDemographic: 'getReportCseitCountsByDemographic',
      rptassessmentCountsByDemographic: 'getReportAssessmentCountsByDemographic',
      rptcseitDemographicsByTime: 'getReportCseitDemographicsByTime',
      rptcseitDemographicsByTimeNoConcern: 'getReportCseitDemographicsByTimeNoConcern',
      rptcseitDemographicsByTimePossibleConcern: 'getReportCseitDemographicsByTimePossibleConcern',
      rptcseitDemographicsByTimeClearConcern: 'getReportCseitDemographicsByTimeClearConcern',
      rptassessmentDemographicsByTime: 'getReportAssessmentDemographicsByTime',
      rptassessmentDemographicsByTimeNoInfoVictims: 'getReportAssessmentDemographicsByTimeNoInfoVictims',
      rptassessmentDemographicsByTimePossibleVictims: 'getReportAssessmentDemographicsByTimePossibleVictims',
      rptCseitIndicators: 'getReportCseitIndicators',
      cseitIndicatorOptions: 'getCseitIndicatorOptions',
      laborScreeningIndicatorOptions: 'getLaborScreeningIndicatorOptions',
      colorValues: 'getColorValues',
      rptpersonDemographicsOverTimeError: 'getReportPersonDemographicsOverTimeError',
      rptpersonCountsByTimeError: 'getReportPersonCountsByTimeError',
      rptPersonCountsByDemographicError: 'getReportPersonCountsByDemographicError',
      rptpersonDemographicsOverTimeUnconfirmedError: 'getReportPersonDemographicsOverTimeUnconfirmedError',
      rptpersonDemographicsOverTimeConfirmedError: 'getReportPersonDemographicsOverTimeConfirmedError',
      rptcseitCountsByTimeError: 'getReportCseitCountsByTimeError',
      rptcseitCountsByDemographicError: 'getReportCseitCountsByDemographicError',
      rptcseitDemographicsByTimeError: 'getReportCseitDemographicsByTimeError',
      rptcseitDemographicsOverTimeNoConcernError: 'getReportCseitDemographicsOverTimeNoConcernError',
      rptcseitDemographicsOverTimePossibleConcernError: 'getReportCseitDemographicsOverTimePossibleConcernError',
      rptcseitDemographicsOverTimeClearConcernError: 'getReportCseitDemographicsOverTimeClearConcernError',
      rptassessmentCountsByTimeError: 'getReportAssessmentCountsByTimeError',
      rptassessmentByDemographicError: 'getReportAssessmentByDemographicError',
      rptassessmentDemographicsByTimeError: 'getReportAssessmentDemographicsByTimeError',
      rptassessmentDemographicsOverTimeNoInfoError: 'getReportAssessmentDemographicsOverTimeNoInfoError',
      rptassessmentDemographicsOverTimePossibleError: 'getReportAssessmentDemographicsOverTimePossibleError',
      rptassessmentIndicatorsError: 'getReportAssessmentIndicatorsError',
      rptCseitIndicatorsError: 'getReportCseitIndicatorsError',
      allUsers: 'getAllUsers',
      allOrgs: 'getAllOrgs',
      allGroups: 'getGroups',
      allLogs: 'getAllLogs',
      screeningsByOrg: 'getScreeningsByOrg',
      laborScreeningsByOrg: 'getLaborScreeningsByOrg',
      locationFilterOptions: 'getLocationFilterOptions',
      laborScreeningFields: 'getLaborScreeningFields'
    }),
    rptLaborScreeningIndicatorsEnds () {
      return this.rptLaborScreeningIndicators.filter(({ field }) => field.startsWith('e_'))
    },
    rptLaborScreeningIndicatorsMeans () {
      return this.rptLaborScreeningIndicators.filter(({ field }) => field.startsWith('m_'))
    },
    rptLaborScreeningIndicatorsProcess () {
      return this.rptLaborScreeningIndicators.filter(({ field }) => field.startsWith('p_'))
    }
  },
  watch: {
    tabIndex (newValue) {
      if (this.hasVisitedTabMap[newValue]) {
        return
      }

      this.hasVisitedTabMap[newValue] = true
      this.fetchStatsByTab(newValue)
    },

    statisticsTimeInterval: function (newValue) {
      if (newValue) {
        this.fetchStats()
      }
    },

    locationFilter: function (newValue) {
      if (newValue) {
        this.fetchStats()
      }
    },

    rptgeneralCounts: function (newValue) {
      if (newValue) {
        if (newValue.personCount === 0) {
          this.percentUnconfirmedPersons = 0
          this.percentConfirmedPersons = 0
        } else {
          this.percentUnconfirmedPersons = Math.round(newValue.possiblePersonCount / newValue.personCount * 100)

          if (newValue.confirmedPersonCount === null) {
            this.percentConfirmedPersons = Math.round(0 / newValue.personCount * 100)
          } else {
            this.percentConfirmedPersons = Math.round(newValue.confirmedPersonCount / newValue.personCount * 100)
          }
        }

        if (newValue.cseitCount === 0) {
          this.percentCseitNoconcern = 0
          this.percentCseitPossibleConcern = 0
          this.percentCseitClearConcern = 0
        } else {
          this.percentCseitNoconcern = Math.round(newValue.cseitCountNoConcern / newValue.cseitCount * 100)
          this.percentCseitPossibleConcern = Math.round(newValue.cseitCountPossibleConcern / newValue.cseitCount * 100)
          this.percentCseitClearConcern = Math.round(newValue.cseitCountClearConcern / newValue.cseitCount * 100)
        }

        if (newValue.assessmentCount === 0) {
          this.percentAssessmentNotenoughinfo = 0
          this.percentAssessmentPossible = 0
        } else {
          this.percentAssessmentNotenoughinfo = Math.round(newValue.assessmentCountNotEnoughInfo / newValue.assessmentCount * 100)
          this.percentAssessmentPossible = Math.round(newValue.assessmentCountPossible / newValue.assessmentCount * 100)
        }

        if (newValue.lsCount === 0) {
          this.percentLsNotEnoughInfo = 0
          this.percentLsVulnerable = 0
          this.percentLsHighlyVulnerable = 0
        } else {
          this.percentLsNotEnoughInfo = Math.round(newValue.lsCountNotEnoughInfo / newValue.lsCount * 100)
          this.percentLsVulnerable = Math.round(newValue.lsCountVulnerable / newValue.lsCount * 100)
          this.percentLsHighlyVulnerable = Math.round(newValue.lsCountHighlyVulnerable / newValue.lsCount * 100)
        }
      }
    },
    demographicField: function () {
      this.fetchPersonCountsByDemographic()
    },
    cseitDemographicField: function () {
      this.fetchCseitCountsByDemographic()
    },
    laborScreeningDemographicField: function () {
      this.fetchLaborScreeningCountsByDemographic()
    },
    demographicByTimeField: function () {
      this.fetchPersonDemographicsByTime()
    },
    demographicByTimeInterval: function () {
      this.fetchPersonDemographicsByTime()
    },
    assessmentDemographicField: function () {
      this.fetchAssessmentCountsByDemographic()
    },
    assessmentDemographicByTimeField: function () {
      this.fetchAssessmentDemographicsByTime()
    },
    assessmentDemographicByTimeInterval: function () {
      this.fetchAssessmentDemographicsByTime()
    },
    assessmentIndicatorOption: function (newValue) {
      const opts = this.getCommonStatsOpts()
      if (newValue !== 'All') {
        opts.dmst_conclusion = newValue
      }
      this.$store.dispatch('getReportAssessmentIndicators', opts)
    },
    cseitDemographicByTimeField: function () {
      this.fetchCseitDemographicsByTime()
    },
    laborScreeningDemographicByTimeField: function () {
      this.fetchLaborScreeningDemographicsByTime()
    },
    cseitDemographicByTimeInterval: function () {
      this.fetchCseitDemographicsByTime()
    },
    cseitIndicatorOption: function (newValue) {
      const opts = this.getCommonStatsOpts()
      if (newValue !== 'All') {
        opts.calc_cseitScore = newValue
      }
      this.$store.dispatch('getReportCseitIndicators', opts)
    },
    laborScreeningIndicatorOption: function (newValue) {
      const opts = this.getCommonStatsOpts()
      if (newValue !== 'All') {
        opts.conclusion = newValue
      }
      this.$store.dispatch('getReportLaborScreeningIndicators', opts)
    },
    usersTimeInterval: function () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getAllUsers', opts)
    }
  },
  data: function () {
    return {
      'someRandomSubsetOfStats': [],
      'assessmentsTimeInterval': 'All',
      'personsTimeInterval': 'All',
      'cseitTimeInterval': 'All',
      'demographicByTimeInterval': 'All',
      'demographicField': 'b_gender_identity',
      'cseitDemographicField': 'b_gender_identity',
      'assessmentDemographicField': 'b_gender_identity',
      'laborScreeningDemographicField': 'b_gender_identity',
      'laborScreeningDemographicByTimeField': 'b_gender_identity',
      'barDemographicField': 'b_gender_identity',
      'statisticsTimeInterval': 'All',
      'hideMonthGraphFilter': false,
      'hideDayGraphFilter': false,
      'demographicByTimeField': 'b_gender_identity',
      'cseitDemographicByTimeField': 'b_gender_identity',
      'assessmentDemographicByTimeField': 'b_gender_identity',
      'cseitDemographicByTimeInterval': 'All',
      'assessmentDemographicByTimeInterval': 'All',
      'assessmentIndicatorsFilter': 'All',
      'assessmentIndicatorOption': 'All',
      'cseitIndicatorOption': 'All',
      'laborScreeningIndicatorOption': 'All',
      'percentUnconfirmedPersons': 0,
      'percentConfirmedPersons': 0,
      'percentCseitNoconcern': 0,
      'percentCseitPossibleConcern': 0,
      'percentCseitClearConcern': 0,
      'percentLsNotEnoughInfo': 0,
      'percentLsVulnerable': 0,
      'percentLsHighlyVulnerable': 0,
      'percentAssessmentNotenoughinfo': 0,
      'percentAssessmentPossible': 0,
      'locationFilter': 'All',
      'customDateRange': {
        'startDate': moment(new Date()).format('ll'),
        'endDate': moment(new Date()).format('ll')
      },
      timezone: moment.tz.guess(),
      tabIndex: 0,
      hasVisitedTabMap: {
        [GLOBAL_REPORTS_TAB_INDEX.DEMOGRAPHICS]: false,
        [GLOBAL_REPORTS_TAB_INDEX.CSEIT]: false,
        [GLOBAL_REPORTS_TAB_INDEX.ASSESSMENT]: false,
        [GLOBAL_REPORTS_TAB_INDEX.LABOR_SCREENING]: false
      }
    }
  },
  methods: {
    handleSelect (customDateRange) {
      this.formatDateRange(customDateRange)
    },

    formatDateRange (customDateRange) {
      this.customDateRange.startDate = moment(customDateRange.startDate).format('ll')
      this.customDateRange.endDate = moment(customDateRange.endDate).format('ll')
    },

    saveCustomDateRange (clickApply) {
      clickApply()
      this.formatDateRange(this.customDateRange)
      if (this.statisticsTimeInterval !== 'Custom') {
        this.statisticsTimeInterval = 'Custom'
      } else {
        this.fetchStats()
      }
    },

    fetchStatsByTab (tabIndex) {
      switch (tabIndex) {
        case GLOBAL_REPORTS_TAB_INDEX.DEMOGRAPHICS:
          this.fetchDemographicsStats()
          break
        case GLOBAL_REPORTS_TAB_INDEX.CSEIT:
          this.fetchCseitStats()
          break
        case GLOBAL_REPORTS_TAB_INDEX.ASSESSMENT:
          this.fetchAssessmentStats()
          break
        case GLOBAL_REPORTS_TAB_INDEX.LABOR_SCREENING:
          this.fetchLaborScreeningStats()
          break
      }
    },

    fetchAssessmentDemographicsByTime () {
      const opts = this.getCommonStatsOpts()
      opts.demographic = this.assessmentDemographicByTimeField
      this.$store.dispatch('getReportAssessmentDemographicsByTime', opts)
      this.$store.dispatch('getReportAssessmentDemographicsByTimeNoInfoVictims', Object.assign(opts, {
        dmst_conclusion: 'No'
      }))
      this.$store.dispatch('getReportAssessmentDemographicsByTimePossibleVictims', Object.assign(opts, {
        dmst_conclusion: 'Yes'
      }))
    },

    fetchLaborScreeningDemographicsByTime () {
      const opts = this.getCommonStatsOpts()
      opts.demographic = this.laborScreeningDemographicByTimeField
      this.$store.dispatch('getReportLaborScreeningDemographicsByTime', opts)
    },

    fetchCseitDemographicsByTime () {
      const opts = this.getCommonStatsOpts()
      opts.demographic = this.cseitDemographicByTimeField
      this.$store.dispatch('getReportCseitDemographicsByTime', opts)
      this.$store.dispatch('getReportCseitDemographicsByTimeNoConcern', Object.assign(opts, {
        calc_cseitScore: 'No Concern'
      }))
      this.$store.dispatch('getReportCseitDemographicsByTimePossibleConcern', Object.assign(opts, {
        calc_cseitScore: 'Possible Concern'
      }))
      this.$store.dispatch('getReportCseitDemographicsByTimeClearConcern', Object.assign(opts, {
        calc_cseitScore: 'Clear Concern'
      }))
    },

    fetchPersonDemographicsByTime () {
      const opts = this.getCommonStatsOpts()
      opts.demographic = this.demographicByTimeField
      this.$store.dispatch('getReportPersonDemographicsOverTime', opts)
      this.$store.dispatch('getReportPersonDemographicsOverTimeUnconfirmed', Object.assign(opts, {
        b_confirmed: 'No'
      }))
      this.$store.dispatch('getReportPersonDemographicsOverTimeConfirmed', Object.assign(opts, {
        b_confirmed: 'Yes'
      }))
    },

    getCommonStatsOpts () {
      const startDate = new Date(this.customDateRange.startDate)
      const endDate = new Date(this.customDateRange.endDate)
      startDate.setHours(0, 0, 0, 0)
      endDate.setHours(23, 59, 59, 999)

      return {
        timeInterval: this.statisticsTimeInterval,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        global: 'True',
        locationFilter: this.locationFilter,
        timezone: this.timezone
      }
    },

    fetchPersonCountsByDemographic () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportPersonCountsByDemographic', Object.assign(opts, {
        demographic: this.demographicField
      }))
    },

    fetchAssessmentCountsByDemographic () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportAssessmentCountsByDemographic', Object.assign(opts, {
        demographic: this.assessmentDemographicField
      }))
    },

    fetchCseitCountsByDemographic () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportCseitCountsByDemographic', Object.assign(opts, {
        demographic: this.cseitDemographicField
      }))
    },

    fetchLaborScreeningCountsByDemographic () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportLaborScreeningCountsByDemographic', Object.assign(opts, {
        demographic: this.laborScreeningDemographicField
      }))
    },

    fetchGeneralCounts () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportGeneralCounts', opts)
    },

    fetchDownloadData () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getAllUsers', opts)
      this.$store.dispatch('getAllOrgs', opts)
      this.$store.dispatch('getGroups', opts)
      this.$store.dispatch('getAllLogs', opts)
    },

    initHasVisitedTabMap () {
      // TODO
      Object.values(GLOBAL_REPORTS_TAB_INDEX).map((tabIndex) => {
        this.hasVisitedTabMap[tabIndex] = false
      })
    },

    fetchStats () {
      this.initHasVisitedTabMap()
      this.fetchGeneralCounts()
      this.fetchDownloadData()
      this.fetchStatsByTab(this.tabIndex)
    },

    fetchDemographicsStats () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportPersonCountsByTime', opts)
      this.fetchPersonCountsByDemographic()
      this.fetchPersonDemographicsByTime()
    },

    fetchCseitStats () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportCseitCountsByTime', opts)
      this.$store.dispatch('getReportCseitIndicators', opts)
      this.$store.dispatch('getScreeningsByOrg', opts)
      this.fetchCseitCountsByDemographic()
      this.fetchCseitDemographicsByTime()
    },

    fetchAssessmentStats () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportAssessmentCountsByTime', opts)
      this.$store.dispatch('getReportAssessmentIndicators', opts)
      this.fetchAssessmentCountsByDemographic()
      this.fetchAssessmentDemographicsByTime()
    },

    fetchLaborScreeningStats () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportLaborScreeningCountsByTime', opts)
      this.$store.dispatch('getReportLaborScreeningIndicators', opts)
      this.$store.dispatch('getLaborScreeningsByOrg', opts)
      this.fetchLaborScreeningCountsByDemographic()
      this.fetchLaborScreeningDemographicsByTime()
    },

    goToConfirmed () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'b_confirmed': 'Yes'
        }
      })
    },

    goToBlankConfirmed () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'b_confirmed': 'No'
        }
      })
    },

    goToNotEnoughInfo () {
      // Not Used Lighthouse Indicators or latest assessment result removed from dashboard.
      this.$router.push({
        path: '/dashboard',
        query: {
          'dmst_conclusion': '0'
        }
      })
    },

    goToPossible () {
      // Not Used Lighthouse Indicators or latest assessment result removed from dashboard.
      this.$router.push({
        path: '/dashboard',
        query: {
          'dmst_conclusion': 'Yes'
        }
      })
    },

    goToNoConcern () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'cseit_conclusion': 'No Concern'
        }
      })
    },

    goToPossibleConcern () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'cseit_conclusion': 'Possible Concern'
        }
      })
    },

    goToClearConcern () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'cseit_conclusion': 'Clear Concern'
        }
      })
    },

    goToLSNotEnoughInfo () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'ls_conclusion': LABOR_SCREENING_CONCLUSION.NOT_ENOUGH_INFO
        }
      })
    },

    goToLSVulnerable () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'ls_conclusion': LABOR_SCREENING_CONCLUSION.LEVEL1
        }
      })
    },

    goToLSHighlyVulnerable () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'ls_conclusion': LABOR_SCREENING_CONCLUSION.LEVEL2
        }
      })
    },

    _getLaborScreeningQuestionBasedOnPrefix (key) {
      if (key.endsWith('otherText')) {
        switch (key) {
          case 'e_fl_otherText':
            return 'Forced Labor - Other'
          case 'e_db_otherText':
            return 'Debt Bondage - Other'
          case 'm_c_otherText':
            return 'Coercion - Other'
          case 'm_fr_otherText':
            return 'Fraud - Other'
          case 'm_fo_otherText':
            return 'Force - Other'
          case 'p_otherText':
            return 'Process - Other'
        }
      }

      switch (true) {
        case key.startsWith('e_fl_'):
          return this.laborScreeningFields.ENDS.FORCED_LABOR[key].label
        case key.startsWith('e_db_'):
          return this.laborScreeningFields.ENDS.DEBT_BONDAGE[key].label
        case key.startsWith('m_c_'):
          return this.laborScreeningFields.MEANS.COERCION[key].label
        case key.startsWith('m_fr_'):
          return this.laborScreeningFields.MEANS.FRAUD[key].label
        case key.startsWith('m_fo_'):
          return this.laborScreeningFields.MEANS.FORCE[key].label
        case key.startsWith('p_'):
          return this.laborScreeningFields.PROCESS[key].label
      }
    },
    transformLaborScreeningIndicatorKey (key) {
      return this._getLaborScreeningQuestionBasedOnPrefix(key)
    }
  },

  mounted () {
    this.fetchStats()
    this.hasVisitedTabMap[GLOBAL_REPORTS_TAB_INDEX.DEMOGRAPHICS] = true
  }
}
</script>
<style>
  #global-statistics-tabs {
    margin-bottom: 50px;
  }
  .clickable-card{
    cursor: pointer;
  }
  .col-sm-6 .text-center {
    width: 400px;
    margin: auto;
  }
  .column-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media screen and (max-width: 548px) {
    .location-filter-select {
      margin: 10px 0;
    }
  }
  .reportrange-text.form-control {
    padding: 0 !important;
    border: none !important;
    overflow: auto !important;
    height: auto !important;
  }

  .date-range-picker__footer {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
    box-sizing: border-box;
  }

  .calendars {
    justify-content: center;
  }

  .date-range-picker__header {
    display: flex;
    padding: 0 5px 10px;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #f2f2f2;
    gap: 5px;
  }

  .date-range-picker__header label {
    margin-bottom: 0;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/views/t1/GlobalReport.vue